import { z } from 'zod';
import { MarketingIndustryTypes } from '../NatureOfBusinessFormProvider/types';
import {
  EMPTY_FIELD_MESSAGE,
  validateEditorEn,
  validateSpace,
  validateSpaceTextInput,
  validateTextEn,
} from '@Utils/validation';
import { uploadImageSchema } from '@Containers/UploadImageFormFields/validators';

enum MARKETING_POLICY_MESSAGE {
  TYPE = 'กรุณาเลือกลักษณะการเปิดเผยข้อมูล',
  DESCRIPTION = 'กรุณาระบุรายละเอียดนโยบายการตลาดของผลิตภัณฑ์หรือบริการที่สำคัญในปีที่ผ่านมา',
  DESCRIPTION_EN = 'กรุณาระบุรายละเอียดนโยบายการตลาดของผลิตภัณฑ์หรือบริการที่สำคัญในปีที่ผ่านมาเป็นภาษาอังกฤษ',
  INDUSTRY_COMPETITION = 'กรุณาระบุรายละเอียดสภาพการแข่งขันภายในอุตสาหกรรมในปีที่ผ่านมา',
  INDUSTRY_COMPETITION_EN = 'กรุณาระบุรายละเอียดสภาพการแข่งขันภายในอุตสาหกรรมในปีที่ผ่านมาเป็นภาษาอังกฤษ',
  ASSETS = 'กรุณาเลือกไฟล์สภาพการแข่งขันภายในอุตสาหกรรมในปีที่ผ่านมา',
  DESCRIPTION_ASSETS_EN = 'กรุณาระบุชื่อรูปภาพ/หัวข้อ/คำอธิบายเพิ่มเติมเป็นภาษาอังกฤษ',
}

enum REMARK_MESSAGE {
  DESCRIPTION_EN = 'กรุณาระบุหมายเหตุเป็นภาษาอังกฤษ',
}

enum INTRO_MESSAGE {
  DESCRIPTION_EN = 'กรุณาระบุคำบรรยายเป็นภาษาอังกฤษ',
}

const IUploadImageSchema = uploadImageSchema({
  assets: MARKETING_POLICY_MESSAGE.ASSETS,
  descriptionAssetsEn: MARKETING_POLICY_MESSAGE.DESCRIPTION_ASSETS_EN,
});

const IntroductionFormSchema = z.object({
  descriptionTh: z
    .string()
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
    .nullable()
    .optional(),
  descriptionEn: z
    .string()
    .regex(validateEditorEn, { message: INTRO_MESSAGE.DESCRIPTION_EN })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
    .nullable()
    .optional(),
});

const RemarkFormSchema = z.object({
  descriptionTh: z
    .string()
    .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
    .nullable()
    .optional(),
  descriptionEn: z
    .string()
    .regex(validateTextEn, { message: REMARK_MESSAGE.DESCRIPTION_EN })
    .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
    .nullable()
    .optional(),
});

const MarketPoliciesSchema = z.object({
  descriptionTh: z
    .string({ message: MARKETING_POLICY_MESSAGE.DESCRIPTION })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
  descriptionEn: z
    .string({ message: MARKETING_POLICY_MESSAGE.DESCRIPTION })
    .regex(validateEditorEn, MARKETING_POLICY_MESSAGE.DESCRIPTION_EN)
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
  industryCompetitionDescTh: z
    .string({
      message: MARKETING_POLICY_MESSAGE.INDUSTRY_COMPETITION,
    })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
  industryCompetitionDescEn: z
    .string({ message: MARKETING_POLICY_MESSAGE.INDUSTRY_COMPETITION })
    .regex(validateEditorEn, MARKETING_POLICY_MESSAGE.INDUSTRY_COMPETITION_EN)
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
  salesRatioIntroduction: IntroductionFormSchema.optional(),
  salesRatioRemark: RemarkFormSchema.optional(),
  assets: z.array(IUploadImageSchema),
});

export const MarketingIndustrySchema = z.object({
  type: z.nativeEnum(MarketingIndustryTypes, {
    message: MARKETING_POLICY_MESSAGE.TYPE,
  }),
  marketingPolicy: z.array(MarketPoliciesSchema),
  introduction: IntroductionFormSchema.optional(),
  remark: RemarkFormSchema.optional(),
  marketingPolicyIntroduction: IntroductionFormSchema.optional(),
  marketingPolicyRemark: RemarkFormSchema.optional(),
});
